export const mezunlar = [
  {
    id: 1,
    isim: "Ayşe Yılmaz",
    bolum: "Biyoloji",
    yorum: "Hacettepe Üniversitesi Biyoloji Bölümü, bana sadece teorik bilgi değil, aynı zamanda eleştirel düşünme ve problem çözme yeteneği kazandırdı. Laboratuvar imkanları ve değerli hocalarımız sayesinde harika bir eğitim aldım.",
    foto: "/mezuniyet.png",
    mezuniyetYili: "",
    pozisyon: "",
  },


 
  {
    id: 6,
    isim: "Mustafa Öztürk",
    bolum: "Biyoloji",
    yorum: "Biyoloji bölümündeki hocalarımız ve araştırma olanakları sayesinde kendimi bilimsel anlamda çok geliştirdim. Hacettepe, bir üniversiteden çok daha fazlası.",
    foto: "/mezuniyet2.png",
    mezuniyetYili: "",
    pozisyon: "",
  },
  {
    id: 7,
    isim: "Elif Şahin",
    bolum: "Biyoloji",
    yorum: "Doğa ve bilimle iç içe geçen dört yıl... Hacettepe Biyoloji, bana hayatı anlamayı öğretti. Mezun olduğumda sadece bir diplomam değil, aynı zamanda harika anılarım vardı.",
    foto: "/mezuniyet.png",
    mezuniyetYili: "",
    pozisyon: "",
  },
  {
    id: 8,
    isim: "Burak Çelik",
    bolum: "Biyoloji",
    yorum: "Arazi çalışmaları ve modern laboratuvarlar, teorik bilgiyi pratiğe dökmemiz için bize inanılmaz fırsatlar sundu. Her anı dolu dolu bir üniversite deneyimiydi.",
    foto: "/mezuniyet2.png",
    mezuniyetYili: "",
    pozisyon: "",
  },
  {
    id: 9,
    isim: "Selin Arslan",
    bolum: "Biyoloji",
    yorum: "Akademik kadronun kalitesi ve sundukları rehberlik, kariyer hedeflerimi şekillendirmemde en büyük etkendi. İyi ki Hacettepeli olmuşum.",
    foto: "/mezuniyet.png",
    mezuniyetYili: "",
    pozisyon: "",
  },

  {
    id: 12,
    isim: "Necibe Serra Kırmızıgül",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/necibeserra.png",
    mezuniyetYili: "2022",
    pozisyon: "Kalite Kontrol Sorumlusu",
    kurum: "D&P perfumum",
    yorum: "Hayalini kurduğum ve her zaman heves ile okumak istediğim kimya bölümünden mezun olmanın gururunu yaşıyorum. Kariyer hayatıma D&P perfumumda kalite kontrol sorumlusu olarak başladım. Hacettepe Üniversitesinin farkını iş hayatında hissetmemi sağlayan ve üzerimde büyük emekleri olan değerli hocalarıma gönülden teşekkürü borç bilirim. Hacettepeli olmaktan her zaman mutluluk duyacağım.",
  },
  {
    id: 13,
    isim: "Hande Erciyes",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/handeerciyesphoto.png",
    mezuniyetYili: "2007",
    pozisyon: "Ruhsatlandırma Operasyonları Müdürü",
    kurum: "H20 Therapeutics",
    yorum: "Üniversite hayatıma ilk başladığımda kimya okuduğumu söylediğimde aldığım ilk tepki şu şekilde oluyordu: \"Öğretmenlik mi Mühendislik mi?\" Maalesef temel bilim olarak Kimya okumaya yaklaşım bu şekilde olsa da, ne kadar kıymetli bir alan seçtiğimi iş hayatıma atıldığımda anladım. Yaklaşık 14 yıldır ilaç sektöründe Kalite, AR-GE, Ruhsatlandırma alanlarında tecrübe kazandıktan sonra şu anda dijital sağlık üzerine bir yazılım şirketi olan \"h20 therapeutics\" de \"Ruhsatlandırma Operasyonları Müdürü\" olarak çalışıyorum. Bu noktaya ulaşabilmek için emek, sabir, disiplinle çok çalışmak felsefemden hiçbir zaman vazgeçmedim. Bu hayat felsefesini edindiğim yer, her biri birbirinden kıymetli hocalarımın sadece Kimya'yı değil tecrübeleriyle de bizi hayata en donanımlı şekilde hazırladıkları Hacettepe Kimya Bölümü oldu. Bu nedenle tüm değerli hocalarıma ve en güzel günlerimin geçtiği okuluma minnet borçluyum. Ayrıca, her ortamda bağıra bağıra dile getirdiğim ve iş hayatında sizi her zaman bir adım öne çıkaracak en önemli gördüğüm unsur ise lütfen yabancı dil gelişiminize yatırım yapın. İngilizceniz ana diliniz gibi olsun",
  },
  {
    id: 14,
    isim: "KARDELEN MERVE ALTUN",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-05-11%20185421.png",
    mezuniyetYili: "2021",
    pozisyon: "World Medicine - Metot Validasyon Uzman Yardımcısı",
    yorum: "Türkiye'nin en iyi üniversitelerinden olan Hacettepe Üniversitesinde Kimya Bölümünde lisansımı bölüm ikincisi olarak tamamladım. Genç bilim insanlarına ışık tutan, tecrübeleriyle, engin bilgileriyle bizlere yol gösteren şahane bir akademik kadroya sahip olan bu bölümden mezun olmaktan gurur duyuyorum. Eğitimimi tamamladıktan ve iş hayatına geçtikten sonra Hacettepeli olmanın farkını çok net görüyorum. Mezuniyetimin hemen ardından 2021 yılında World Medicine'nin ARGE departmanında Metot Validasyon Uzman Yardımcısı olarak işe başladım. Araştırmanın ilk tohumlarının ekildiği üniversitemin ardından ilaç sektöründe de bu araştırma ve geliştirme tutkumu devam ettiriyorum. Kariyer basamaklarını birer birer çıkmak öncelikle eğitimle başlıyor.",
  },
  {
    id: 15,
    isim: "ZEHRA OLUZ YAZLAK",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-05-11%20185537.png",
    mezuniyetYili: "2010",
    pozisyon: "UNIVERSITY OF CHICAGO - DOKTORA SONRASI ARAŞTIRMACI",
    yorum: "Hacettepe Üniversitesi Kimya Bölümü 2010 yılı mezunuyum. Bu bölümde 4 yıl boyunca keyifle okudum, öğrendim, denedim ve de geliştim. Alanının önderi olan akademisyenlerin derslerine ve ileride bu önderliği ele alacak olan araştırma görevlilerinin laboratuvar uygulamalarına katılma fırsatı elde ettim. Üniversite yıllarımı, kampüs hayatını bu kadar keyifli bir şekilde sunan bir üniversitede geçirdiğim için kendimi çok şanslı hissediyorum. Şu anda dünyanın önde gelen üniversitelerinden birisi olan University of Chicago'da doktora sonrası araştırmacı pozisyonunda çevre dostu polimere günlük hayatta kullanımlarını yaygınlaştıracak mekanik özellikler kazandırılması üzerine çalışmaktayım. Karakterinizle örtüşen, hayat amacınıza hizmet eden yönde ilerlerken, seçeceğiniz bölüm ve okulun yanı sıra ortaya koyacağınız akademik ve sosyal alanlardaki emeğin de fark yaratacağını unutmamanızı dilerim.",
  },
  {
    id: 16,
    isim: "ÇAĞLA NUR ALKIŞ",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/caglanuralkisphoto.png",
    mezuniyetYili: "2022",
    pozisyon: "İskur Group Tekstil Enerji- R&D Specialist",
    yorum: "Her çocuğun bir hayali vardır. Benim en büyük hayalimdi kimya. Kimyaya olan tutkum küçük yaşlarda başlamış olsa da bilim yuvası olan Hacettepe Üniversitesi Kimya Bölümünde almış olduğum kaliteli eğitim süresince bu tutkum daha da arttı. Bu gönül yolculuğumda elimden tutan kendimi hangi sektörde olmak istediğime kariyer hayatımın planlamasında emeği geçen saygıdeğer hocalarıma ve Hacettepe'nin tüm çalışanlarına teşekkürlerimi sunuyorum. Ve bir Hacettepeli olmaktan gurur duyuyorum. Mustafa Kemal'in yıllar önce gönderdiği gibi, birer kıvılcım gibi gidiyoruz ama elbette birer alev olarak döneceğiz.. 'Daha İleriye... En İyİye... Hacettepe...'",
  },
  {
    id: 17,
    isim: "DENİZ ÖZGE ÇOLAK",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/denizozgecolakphoto.png",
    mezuniyetYili: "2019",
    pozisyon: "Latro Kimya Dış Ticaret Anonim Şirketi New Possibility Creator",
    yorum: 'Merhaba, ben Deniz Özge. Hacettepe\'deki eğitimim boyunca hocalarımdan aldığım eğitimle beslediğim kimya tutkum ve üniversitemizin sağladığı özgür oyun alanından ilham alarak kariyerime başladım. Bana bu şevki aşılayan Hacettepe Üniversitesi ve onun kampüsünde soluduğum hava gelecek için bir vizyon edinmemi sağladı. Elementlerin molekülleri oluşturması ve moleküllerin de reaksiyonları oluşturması gibi, insanın kendi yolculuğunun da yaşadığı toplumda bir kelebek etkisi yaratarak ne kadar etkili olabileceğini gördüm. Bu nedenle Hacettepe\'den mezun bir kimyager olarak üniversite tercihlerini yapacak yeni Hacettepelilere şunu söylemek istiyorum: "Kendi kimyanızı keşfetmeye, Hacettepe\'yi keşfederek başlayın". Yolunuz açık olsun.',
  },
  {
    id: 18,
    isim: "CANSU ÇELİK",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/cansucelikphoto.png",
    mezuniyetYili: "2021",
    pozisyon: "İSKO - Kimyasal Geliştirme Departmanı Ar-Ge kimyageri",
    yorum: "Hacettepe Kimya'dan 2021 yılında mezun oldum. İSKO'da Kimyasal Geliştirme departmanında AR-GE çalışmaları yapıyorum. Kimya sektörünün bana göre en güzel yanlarından biri çok çeşitli alanlarda aktif olması ve bu sayede kendinize yakın olan alanı seçip burada ilerleyebilmenizdir. Sevdiğim mesleği yapabilmemin birincil ve en güzel sebebi olan Hacettepe Kimya'nın bir parçası olmaktan çok mutluyum.",
  },
  {
    id: 19,
    isim: "CEMRE YILDIZ",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/cemreyildizphoto.png",
    mezuniyetYili: "2017",
    pozisyon: "Çekya Charles Üniversitesi PhD öğrencisi",
    yorum: "2017 yılında Hacettepe Üniversitesi Kimya Bölümünden mezun oldum ve akabinde aynı bölümde yüksek lisansımı bitirdim. Daha sonra Çekya'da Charles Üniversitesinde doktoraya kabul aldım ve çalışmalarıma devam etmekteyim. Bu eğitim serüvenime Hacettepe Üniversitesi gibi köklü bir üniversitede başlamak benim için çok büyük bir şans oldu. Lisans eğitimim boyunca aldığım kimya eğitimi beni buralara getirdi. Değerli hocalarıma verdikleri emeklerinden dolayı teşekkür ediyorum.",
  },
  {
    id: 20,
    isim: "İLKAY SÖKMEN",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/ilkaysokmenphoto.png",
    mezuniyetYili: "1997",
    pozisyon: "Şişecam Bilim Teknoloji ve Tasarım Merkezi Cam Teknolojileri Direktörü",
    yorum: "Yenilikçi ürün ve teknoloji geliştirme alanlarında öncü olan kurumsal şirketlerin Ar-Ge çalışmalarında temel bilimlere çok önem verdiklerini görüyorum. Çalıştığım kurumda da Kimya alanında temel bilim eğitimi almış olmamın avantajını her zaman yaşadım. Bunun yanı sıra değerli hocalarımdan aldığım geniş vizyon ile disiplinler arası çalışmaya açık ve istekli bir birey olarak yetişmemin yanı sıra problem çözme ve karar verme yetenekleri kazandığımı da vurgulamak isterim.",
  },
  {
    id: 21,
    isim: "BEGÜM SARIASLAN",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/beg%C3%BCmsariaslanphoto.png",
    mezuniyetYili: "2013",
    pozisyon: "No:21 Eğitim ve Yayıncılık Kurucu Ortak ve Kimya Öğretmeni",
    yorum: "Kimya bölümü mezunu olmak kişiye oldukça geniş iş olanakları sağlamaktadır. Sadece iş hayatı değil günlük yaşantıda da kişiye farklı bakış açısı kazandırmaktadır. Kimya aşığı bir insan olarak ben her yılını ayrı bir keyifle okudum. Hacettepe gibi köklü ve akademik kadrosu sağlam bir üniversiteden mezun olmanın avantajlarını da iş hayatımda gördüm. Tüm hocalarıma bize kazandırdıkları için çok teşekkür ediyorum.",
  },
  {
    id: 22,
    isim: "FULYA ELGİN",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-05-11%20185741.png",
    mezuniyetYili: "2002",
    pozisyon: "Şişecam Bilim Teknoloji ve Tasarım Merkezi Bölge Laboratuvarları Müdürü",
    yorum: "2002 yılında Hacettepe Üniversitesi Kimya Bölümünden mezun oldum. Daha sonra aynı bölümde Yüksek Lisans ve Doktora programlarını tamamladım. Meslek hayatıma Araştırma Görevlisi olarak başladım ve 20 yıldır farklı sektörlerde birçok farklı pozisyonda kimyager olarak çalıştım. Çalışma hayatım boyunca Hacettepe Kimya'dan almış olduğum eğitimin kalitesini ve avantajını her zaman gördüm.",
  },
  {
    id: 23,
    isim: "AYÇA DUMAN",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aycadumanphoto.png",
    mezuniyetYili: "2021",
    pozisyon: "Elso Kimya R&d Formulation Assistant Speacialist",
    yorum: "Hacettepe Üniversitesi kimya bölümü köklü tarihi ve başarılı akademik kadrosu ile lisans eğitimime ve kişisel gelişimime büyük ölçüde katkı sağlarken, dönem içerisinde aldığım seçmeli dersler ile kendime hangi sektörde bir başlangıç sunacağıma karar vermemi sağladı. Hacettepeli olmanın ayrıcalığı ile mezun olduktan çok kısa bir süre sonra istediğim sektörde iş bulma avantajım oldu.",
  },
  {
    id: 24,
    isim: "BENGİSU SARAÇLAR",
    bolum: "Kimya",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/bengisusaraclarphoto.png",
    mezuniyetYili: "2021",
    pozisyon: "DROGSAN R&D Assistant Specialist",
    yorum: 'Hayatımızın en güzel yaşlarını geçirdiğimiz dönem şüphesiz ki üniversite dönemimiz oluyor. Bilgiye, öğrenmeye ve keşfetmeye en yatkın olduğumuz bu yaşlarda bir o kadar da toy oluyoruz. Lisans eğitimim boyunca almış olduğum teorik ve pratik eğitimlerin yanı sıra, bilgi ve tecrübeleriyle yolumuza ışık olan değerli akademisyenlerimizin bana kattıklarıyla 2021 yılı Haziran ayında Hacettepe Üniversitesi Kimya Bölümünden mezun oldum, 2022 yılı Ocak ayında ise Drogsan İlaçları\'nda ARGE Uzman Yardımcısı olarak işe başladım. Her zaman söylenen, benim de eğitim hayatımda sıklıkla duyduğum "Hacettepeli olmak ayrıcalıktır." sloganını bilhassa deneyimlemek gurur verici.',
  },
  {
    id: 25,
    isim: "Armağan Can Evci",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/armagancanevci.jpg",
    mezuniyetYili: "2011",
    pozisyon: "Teknik Ürün Yöneticisi",
    kurum: "Dgpays",
    yorum: "Hacettepe Üniversitesi Matematik Bölümü gerek değerli akademisyen kadrosu ve sunmuş olduğu eğitimle, gerekse sağlamış olduğu sosyal olanaklar sayesinde bana çok güzel bir üniversite deneyimi yaşattı ve kariyerim için farklı alternatiflere hazırlıklı olmamı sağladı. Çalışmış olduğum şirket ve pozisyonlarda bölümdeki eğitim sayesinde geliştirdiğim disiplin, farklı çözümler bulma, analitik düşünme becerilerim hep fark yaratmamı sağladı. Bölümde almış olduğunuz eğitim sayesinde akademik yönde bir kariyer yolu çizebileceğiniz gibi, kamu kurumlarında ya da özel sektörde yazılım, iş analizi, öğretmenlik gibi birçok farklı alanda da ilerleyebilirsiniz.",
  },
  {
    id: 26,
    isim: "Cafer Çavdar",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/cafercavdar.jpg",
    mezuniyetYili: "2005",
    pozisyon: "Dijital Pazarlama Direktörü, Kurumsal İletişim ve Pazarlama Direktörü",
    kurum: "MlpCare, İstinye Üniversitesi",
    yorum: "Matematik okumak bana pazarlama alanında analitik düşünme ve raporlama süreçlerinde önemli katkılar sağladı. Büyük veri ve yapay zeka algoritmaları ile anlık veri akışları içerisinden stratejik karar alma süreçleri olusturuyorum, bu kapsamda Matematik Bölümü'nde aldığım eğitimin oluşturduğu alt yapı kilit noktasi olmuştur.",
  },
  {
    id: 27,
    isim: "Yasemin Kerküklü Demir",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/yaseminkerkukludemir.jpg",
    mezuniyetYili: "2014",
    pozisyon: "Proje Asistanı, Savunma Sanayii Başkanlığı",
    yorum: "Hacettepe Üniversitesi Matematik Bölümü'nü 2014 yılında bitirdikten sonra yine Hacettepe Üniversitesi'nde formasyon eğitimi alarak çeşitli eğitim kurumlarında öğretmenlik yaptım. Daha sonra 2017 yılında Savunma Sanayii Başkanlığı'nda Proje Asistanı olarak göreve başladım ve görevime halen devam etmekteyim. Savunma Sanayii Başkanlığı'nda çalışırken Gazi Üniversitesi İşletme Bölümü'nde yüksek lisansımı tamamladım ve daha sonra Ahmet Yesevi Üniversitesi'nde Endüstri Mühendisliği Bölümünü bitirdim. Bölümde almış olduğum bazı dersler sayesinde endüstri mühendisliğini zorlanmadan bitirdim. Matematik bölümü zor bir bölüm olmasına rağmen bölüm hocalarımızın destekleri sayesinde bölümü çok severek okudum. Matematiğin bize kazandırmış olduğu analitik düşünme, sorgulama, analiz yeteneği sayesinde hem günlük hayatımızda hem de iş hayatımızda karşımıza çıkan birçok probleme karşı farklı bakış açıları oluşturabilmekteyiz ve çözüm odaklı düşünebilmekteyiz.",
  },
  {
    id: 28,
    isim: "Zehra Yaşar",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/zehrayasar.jpg",
    mezuniyetYili: "2010",
    pozisyon: "Yazılım Mühendisi, Amazoi Software",
    yorum: "Matematik Bölümü'nü bitirdikten sonra Hacettepe Üniversitesi, Bilişim Enstitüsü'nde Yazılım Mühendisliğinde yüksek lisans yaptım ve 2018 yılında mezun oldum. ODTÜ Teknokent ve Bilkent Cyberpark şirketlerinde savunma sanayi ve dijital müze sektörlerinde 7 yıl çalıştıktan sonra 2018 yılında Tübitak Ar-Ge desteği ile Amazoi Software şirketini kurdum. 2022 yılının başında ise yatırım alarak Amazoi Teknik Simülasyon AŞ ‘nin kurucu ortağı oldum. Hacettepe Matematik bölümü bana analitik düşünme becerisinin yanında birçok farklı özellik ve bakış açısı kattı. Kendimi geliştirme fırsatı sundu ve yazılım alanına yönelmemde bana ilham oldu. Özellikle Prof. Dr. Haşmet Gürçay hocam yazılıma olan ilgimin artmasında ve farklı bakış açıları geliştirmemde öncülük etti. Bölümde almış olduğumuz eğitim sayesinde şu an ki mevcut çalışma hayatımdaki disiplini ve analitik düşünme becerilerimi edinmiş oldum. Hacettepe matematik bölümünde aldığınız eğitimle kendi ilgi ve istekleriniz doğrultusunda birçok farklı alana yönelebilir ve kendinize en uygun kariyeri oluşturabilirsiniz.",
  },
  {
    id: 29,
    isim: "Hasan Dilek",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/hasandilek.png",
    mezuniyetYili: "2011",
    pozisyon: "Hava Trafik Kontrolörü, Devlet Hava Meydanları İşletmesi",
    yorum: "Matematiğin bize kazandırdığı düşünme, sorgulama, kavrama ve öğrenme yeteneği hayatımızın her alanında yardımcı oluyor. Hacettepe Matematik bölümünün lisans programı müfredatının faydasını özellikle yüksek lisans yaparken gördüm. Çünkü yüksek lisansta aldığım yeni derslerin birçoğu lisansta bize anlatılmıştı. Bölümü okurken biraz zorlasa da avantajını mezun olduktan sonra çok daha net anladım. Bu açıdan Hacettepe'nin ve Matematik bölümünün yeri her zaman ayrı ve özel olacaktır. Bizlere katkı sağlayan tüm hocalarıma teşekkür ederim.",
  },
  {
    id: 30,
    isim: "Dr. Elif Özcan Tok",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/elif.png",
    mezuniyetYili: "2010",
    pozisyon: "Ekonomist, T.C. Merkez Bankası",
    yorum: "Hacettepe Üniversitesi Matematik Bölümü, hem kaliteli ve sorgulatan eğitim programı hem de sosyal yaşantısıyla beni geleceğe çok iyi hazırladı. En önemlisi, çalışarak herşeyin öğrenilebileceğini gösterdi. Bölümümün bana kazandırdığı bilgi birikimi ve analitik düşünme yeteneği akademik hayatta ve iş hayatında başarılı olmamı sağladı.",
  },
  {
    id: 31,
    isim: "Mehmet Taçalan",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/mehmettacalan.png",
    mezuniyetYili: "2011",
    pozisyon: "Kobi Müşteri İlişkileri Yöneticisi, Akbank",
    yorum: "Matematik'e olan sevginizi birçok alana aktarabileceğiniz bir bölümde okumanın farkına vararak terchinizi kaliteli eğitimi ve deneyimli öğretim kadrosu ile Türkiye'de en başarılı bölümlerden biri olan Hacettepe Matematik Bölümü'nden yana yapmanız size mezuniyette fazlasıyla seçenek sunacaktır. Analitik düşünme, analiz becerisi ve karar verme noktasında edineceğiniz başarımlar sonucunda mezun olduktan sonra akademik kariyer veya öğretmenlik dışında özel sektörde iş analisti, veri analisti, yazılım vs gibi yeteneklerinizi kullanabileceğiniz birçok alanda seveceğiniz işi yapabilirsiniz. Bölüm hocalarıma emekleri ve destekleri için ayrı ayrı çok teşekkür ederim. Lisans günlerine özlemle ve hasretle..",
  },
  {
    id: 32,
    isim: "Ceren Coşkun",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/cerencoskun.png",
    mezuniyetYili: "2011",
    pozisyon: "Bilimsel Programlar Uzmanı, TÜBİTAK",
    yorum: "Matematik bölümünden mezun olmak, yönlendiğiniz her alanda size kattığı bakış açısıyla farklı iş alanlarına yönelebilme becerisi kazandırmaktadır. Hacettepe Matematik bölümü bu anlamda öğretim kadrosuyla ülkedeki en iyi matematik bölümlerinden biridir. Mezun olduktan sonra girebileceğiniz her alanda bölümün size kazandırdığı çok yönlü düşünebilme, problem çözebilme kazanımlarını kullanmanız her zaman daha verimli ve birkaç adım önde çalışmanıza katkı sağlamaktadır.",
  },
  {
    id: 33,
    isim: "Dr. Cemile Kürkoğlu",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/cemilekurkoglu.png",
    mezuniyetYili: "2013",
    pozisyon: "Assistant Professor, Denison University",
    yorum: "Matematik sadece formüllerden, denklemlerden, cebirden, analizden ibaret değil.. Analitik düşünme, sorgulama, kıyas yaparak karar verme… asıl bunlar her Matematik bilen kişinin kazandığı önemli değerler.. Bu anlamda keşke hepimiz matematiği sadece bir bilim dalı olarak değil, hayatın hemen hemen her alanında bize yardım eden, yol gösteren bir ışık olarak da görebilsek. Ben şanslıydım; bunu bana ilk gösteren Hacettepe Matematik Bölümü ve değerli hocalarım oldu. Bu anlamda Hacettepe'nin benim için yeri çok ayrı, çok özel. Gerek kuramsal derslerle, gerek seçmeli derslerle bana her yönüyle matematiği tanıma imkanını ve yükseklisans ve doktora için gerekli motivasyonu bana verdiği için bölümüme çok teşekkür ediyorum.",
  },
  {
    id: 34,
    isim: "Ayşe Merve Uzun",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aysemerveuzun.png",
    mezuniyetYili: "2012",
    pozisyon: "Kariyer Uzmanı, T.C. Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı",
    yorum: "Öğrenciyken 'Matematik okuyorum' dediğimde 'Öğretmenlik mi?' sorusuyla karşılaştığım çok zaman olmuştur. Matematik bölümünün düşünsel kalıpların ne kadar dışına taşabileceğini mezun olduktan sonra daha net idrak edebildim. Sınırları aşmanın en önemli anahtarı ise bize kazandırılan analitik düşünebilme ve karar verebilme yeteneğidir. Bu anlamda değerli hocalarıma ve okuluma minnet borçluyum.",
  },
  {
    id: 35,
    isim: "Burak Şimşek",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/buraksimsek.png",
    mezuniyetYili: "2020",
    pozisyon: "4HERA Yazılım Geliştirme Ekip Lideri",
    yorum: "İlk yılları bir miktar zorlu geçse de iyi ki okumuşum dediğim bir bölüm. Özellikle 3. ve 4. sınıfta aldığınız seçmeli dersler iş hayatınıza büyük ölçüde yön veriyor. Öğrenim döneminde birçok beceriler kazanıyoruz. Analitik düşünme, problem analiz edebilme, matematiksel modelleme ve çok daha fazlası. Kazanılan bu beceriler sizi iş hayatında ve sosyal hayatta farklı bir insan yapıyor. İleride yazılım sektöründe çalışmak isteyen arkadaşlarıma tavsiye edeceğim bölüm, H.Ü. Matematik Bölümü'dür. Not: Yazılım alanında çalışmak istiyorsanız bölümü kazandığınız an adım atmalısınız. :) Unutmayalım ki bölüm, nitelikli Matematikçiler yetiştirmeyi hedefliyor. İyi bir matematikçi ve iyi bir yazılımcı olmak istiyorsanız doğru yerdesiniz.",
  },
  {
    id: 36,
    isim: "Berkay Akdeniz",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/berkayakdeniz.png",
    mezuniyetYili: "2014",
    pozisyon: "Deneyimli Yazılım Uzmanı, Akbank",
    yorum: "Bölümde almış olduğumuz eğitim, karşılaştığımız olaylara birden fazla bakış açısı ile bakmamızı sağlıyor. Hızlı ve derinlemesine sorgulayabiliyoruz. Yazılım sektöründe ise her geliştirmenin en etkili ve verimli yolunu bulmak hayati öneme sahiptir. Farklı çözüm yollarını arama isteği de almış olduğumuz dersler sayesinde gelişiyor. Bu da bizleri iş hayatında öne çıkartıyor. İşe giriş sürecinde deneyiminizi ve yeterliliğinizi ölçtükleri gibi bir olay yaratıp probleme yaklaşımlarınızı, hangi noktadan başladığınızı ve çözümlerinizi de görmek istiyorlar. Bu noktada bölümümüzün bize kazandırdığı soyut ve analitik düşünceyi kullanabiliyorsunuz. Yazılım sektöründe matematik mezunlarının ciddi bir ağırlığı var. Altı yıla yakın tecrübemde birçok farklı sektörün IT bölümünde matematik mezunları ile çalışma fırsatı buldum.",
  },
  {
    id: 37,
    isim: "Özgür Özden",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/ozgurozden.png",
    mezuniyetYili: "2012",
    pozisyon: "İdari ve Sosyal İşler Şube Müdürü, BOTAŞ",
    yorum: "Matematik Bölümü'nde okumayı dört sene boyunca sorgulamış birisi olarak bana katmış olduklarını is hayatıma başladığımda fark edebildim. Hem çalışma hem de sosyal hayatımda bana yön veren, analitigin ve analizin sadece bir ders olmadığını öğreten bölümüme ve hocalarıma teşekkürlerimi sunuyorum.",
  },
  {
    id: 38,
    isim: "Emre Karataşoğlu",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/emrekaratasoglu.png",
    mezuniyetYili: "2011",
    pozisyon: "Vimesoft Arge ve Yazılım Geliştirme Direktörü",
    yorum: "Matematik Bölümü mezunları olarak, farklı alanlarda başarılı olabilmemizin sebebi, okurken farkında olmadan geliştirdiğimiz, hızlı matematiksel modelleme yapabilme ve sebep sonuç analizi çıkarabilme kabiliyetimiz diye düşünüyorum. Çünkü sektör ne olursa olsun, bu iki özellik bizi çok ön plana çıkarıyor. Çevremizdeki çoğu gündelik olay problem çözme üzerine kuruludur. Yazılım tarafında bakacak olursak, matematik probleminden farksızdır. Her şey CRUD (Create Read Update Delete) döngüsünde geçiyor ve bu bir matematikçinin yapabildiği en iyi şeylerden biridir.",
  },
  {
    id: 39,
    isim: "Uğur Cengiz",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/ugurcengiz.png",
    mezuniyetYili: "2012",
    pozisyon: "Hava Trafik Kontrolörü, Devlet Hava Meydanları İşletmesi",
    yorum: "Matematik Bölümü'nden aldığım eğitim bana yaşamımın her alanında analitik düşünme yetisi kazandırdı. Daha programlı ve planlı düşünmeye başladım ve bu durum gerek girdiğim sınavlarda gerek şimdiki işimde kolaylıklar sağladı. Mezuniyet sonrası girdiğim KPSS'de Matematik alanında birinci olmamın en büyük yardımcısı bölümden kazanmış olduğum çalışma prensibidir. Yine şimdiki işimde gerekli olan soyut düşünme, çözüm üretebilme, analitik düşünme gibi becerilerimi aldığım eğitime borçluyum.",
  },
  {
    id: 40,
    isim: "Aslı Şenkul",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aslisenkul.png",
    mezuniyetYili: "2005",
    pozisyon: "Müdür Yardımcısı, Türkiye Kalkınma ve Yatırım Bankası İç Kontrol ve Uyum Birimi",
    yorum: "Matematik Bölümü'nden mezun olmak, hayatınız boyunca bunu duyan insanların hayranlık dolu bakışlarına maruz kalmanız, yarattığı düşünsel farkla iş yaşamınızı kolaylıkla şekillendirebilmeniz demektir. Ben, Hacettepe Üniversitesi, Matematik Bölümü'nün bana kattığı bilgi birikimi ve bakış açısı ile bankacılık sektörünün pazarlama, teftiş, uyum ve iç kontrol gibi farklı alanlarında görev yapma şansına sahip oldum. Bizleri hayata en iyi şekilde hazırlayan hocalarımıza teşekkürlerimi sunuyorum.",
  },
  {
    id: 41,
    isim: "Dr. Zümra Kavafoğlu",
    bolum: "Matematik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/zumrakavafoglu.png",
    mezuniyetYili: "2007",
    pozisyon: "Dr. Öğr. Üyesi, H. Ü. Bilişim Enstitüsü",
    yorum: "Matematik eğitimi almış olmanın ne kadar ayrıcalıklı olduğunu Bilgisayar Bilimleri alanına yöneldiğimde daha iyi anladım. Bilgisayar Grafiği ve Animasyonu, Yapay Zeka, Makine Öğrenmesi gibi alanlarda sağlam bir Matematik temeline, analitik düşünme yeteneğine ve zor Problemleri çözme cesaretine sahip olmanın avantajı çok büyük. Hacettepe Matematik Bölümü'nde alacağınız eğitimle bu niteliklere fazlasıyla sahip olacaksınız.",
  },
  {
    id: 42,
    isim: "Simgesima Serez",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/simgesimaserez.png",
    mezuniyetYili: "2022",
    pozisyon: "Reasürans Uzman Yardımcısı",
    kurum: "Ray Sigorta A.Ş.",
    yorum: "İstatistik, matematik ve bilgisayar programlama bilimlerinin harmanlanmış olması ve en önemlisi her zaman yeni bilgiler öğrenebileceğim, inovasyona açık bir bölüm olması sebebiyle aktüerya bilimleri bölümünü tercih ettim.",
  },
  {
    id: 43,
    isim: "Berke Dilmen",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/berkedilmen.png",
    mezuniyetYili: "2022",
    pozisyon: "Aktüeryal Fiyatlandırma Yetkilisi",
    kurum: "AgeSA Hayat ve Emeklilik A.Ş.",
    yorum: "Belirsizliklere ışık tutabilmeyi öğretir.",
  },
  {
    id: 44,
    isim: "Rana Türkoğlu",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/ranaturkoglu.png",
    mezuniyetYili: "2022",
    pozisyon: "Oto Teknik Uzman Yardımcısı",
    kurum: "Ray Sigorta A.Ş.",
    yorum: "Mezun olduktan hemen sonra işe girmem bir kere daha bu bölümü seçmemin ne kadar mantıklı olduğunu gösterdi.",
  },
  {
    id: 45,
    isim: "Nalan Işık",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/nalanisik.png",
    mezuniyetYili: "2022",
    pozisyon: "Fiyatlandırma ve Tarife Yönetimi Uzman Yardımcısı",
    kurum: "Generali Sigorta",
    yorum: "Aktüer ihtiyacının hiçbir zaman bitmeyeceğini bildiğim ve karar verici olmayı sevdiğim için bu bölümü tercih ettim.",
  },
  {
    id: 46,
    isim: "Furkan Arıkel",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/furkanarikel.png",
    mezuniyetYili: "2022",
    pozisyon: "Aktüerya Uzman Yardımcısı",
    kurum: "Ray Sigorta A.Ş.",
    yorum: "",
  },
  {
    id: 47,
    isim: "Mert Berber",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/mertberber.png",
    mezuniyetYili: "2021",
    pozisyon: "Denetim ve Danışmanlık / Aktüerya",
    kurum: "PricewaterhouseCoopers (PwC)",
    yorum: "Zincir-Merdivenin basamaklarını adım adım tırmanıp zirveye ulaşabileceğiniz tek yer burası. Çalıştığım şirketteki ekibimiz 14 kişi, 12si Hacettepe Aktüerya Bilimleri mezunu, Hacettepe'li olmak ayrıcalıktır.",
  },
  {
    id: 48,
    isim: "Can Yıldırım",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/canyildirim.png",
    mezuniyetYili: "2021",
    pozisyon: "Teknik Uzman ve Koordinatör",
    kurum: "Timurlar Sigorta Aracılık Hizmetleri",
    yorum: "Yurtdışı ayağı köklü ve sağlam bir alan.",
  },
  {
    id: 49,
    isim: "Can Berk Bartu",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/canberkbartu.png",
    mezuniyetYili: "2021",
    pozisyon: "Business Analyst",
    kurum: "Vizyoneks Information Technology",
    yorum: "Giriş yılımızda bir çok bölümle denkleğinin olması, matematik sevenlerin tercih etmesi gerektiği, bir kolunun yazılıma ayrıldığı prestijli bir bölüm olması.",
  },
  {
    id: 50,
    isim: "Tunaberk Buğra Özer",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/tunaberkbugrayavuz.png",
    mezuniyetYili: "2020",
    pozisyon: "Kıdem Tazminatı Yükümlülüğü Aktüeryal Değerlemesi ve Destekten Yoksun Kalma Tazminatı Hesaplaması, Yüksek Lisans Öğrencisi",
    kurum: "Adendum Aktüerya Emeklilik Danışmanlık Hizmetleri Ltd. Şti., H.Ü. Aktüerya Bilimleri",
    yorum: "Matematik ve istatistik kullanarak finansal alanda ileriye yönelik tahminler yapacak, prestijli ve bol kazançlı bir mesleğe sahip olmak için Aktüerya. Risk almayın, risk hesaplayın. ☺",
  },
  {
    id: 51,
    isim: "Ayberk Yavuz",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/ayberkyavuz.png",
    mezuniyetYili: "2020",
    pozisyon: "Hayat Dışı Rezerv Aktüerya Uzmanı",
    kurum: "Allianz Sigorta",
    yorum: "Özel güçlere sahip olmadan rakamlarla geleceği tahmin edebilenlerin ortak noktası.",
  },
  {
    id: 52,
    isim: "Merve Eryiğit",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/merveeryigit.png",
    mezuniyetYili: "2018",
    pozisyon: "Uzman Yardımcısı",
    kurum: "Halk Bankası",
    yorum: "Yeniliklere ve gelişmeye her daim açık, teorik bilgilerin yanında aynı zamanda hayata bakış açımı ve vizyonumu geliştirdiği için iyi ki Aktüerya Bilimleri.",
  },
  {
    id: 53,
    isim: "Muammer Duman",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/muammerduman.png",
    mezuniyetYili: "2018",
    pozisyon: "Aktüeryal Danışman",
    kurum: "PricewaterhouseCoopers (PwC) Denetim, Vergi ve Danışmanlık Hizmetleri",
    yorum: "Geçmişi ve bugünü öğrenip yarını keşfeden, donanımlı bir 'Aktüer' olma yolunda; analitik düşünebilme, kodlama, verileri istatistiksel yöntemlerle analiz edebilme gibi yetilerimi üst düzeyde geliştirebilmek için başta her zaman yanımızda olan başarılı akademik kadrosu ve kapsamlı ders programı ile 'Aktüer' mesleğine yapılacak en doğru başlangıç olarak Aktüerya Bilimleri Bölümü'nü tavsiye ediyorum.",
  },
  {
    id: 54,
    isim: "Ezgi Uçar",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/ezgiucar.png",
    mezuniyetYili: "2017",
    pozisyon: "Araştırma Görevlisi",
    kurum: "Ankara Üniversitesi Aktüerya Bilimleri Bölümü",
    yorum: "Aylarca süren araştırmaların ardından, yalnızca başkalarının çözemediği bir sorunu çözmekle kalmayıp, çözümünüzün gerçek dünyayı etkilediğini bilmek gurur verici.",
  },
  {
    id: 55,
    isim: "Emre Can Demirkaya",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/emrecandemirkaya.png",
    mezuniyetYili: "2017",
    pozisyon: "Aktüeryal Fiyatlandırma ve Teknik Analiz",
    kurum: "Ak Sigorta A.Ş.",
    yorum: "Çok fazla bilinmediği için, kendini verimli bir şekilde geliştiren ve çalışan herkesin kıymetli bir çalışan konumuna gelebileceği, kısa vadede çok daha değerli bir alan olacağını düşündüğüm için bu alana yöneldim.",
  },
  {
    id: 56,
    isim: "Duygu Büyükbaş",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/duygubuyukbas.png",
    mezuniyetYili: "2017",
    pozisyon: "Stratejik Pazarlama ve Müşteri Deger Yönetimi Departmanı Ürün ve Proje Yöneticisi",
    kurum: "Ak Sigorta A.Ş.",
    yorum: "Hacettepe Aktüerya analitik düşünme yeteneğini kazanmanızı sağlayacaktır, bu analitik düşünme ise bir cok sektörün hangi alanında çalışırsanız çalışın size çok fayda sağlayacaktır . Ayrıca sigorta sektöründe Aktüerya mezunu olmanın işe alım sürecinde sizi ne kadar ön plana çıkaracağını farkedeceksiniz çünkü sizi sigorta sektörünün beyni olarak göreceklerdir.",
  },
  {
    id: 57,
    isim: "Gökşen Nur Orhan",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/goksennurorhan.png",
    mezuniyetYili: "2016",
    pozisyon: "Bireysel Kurumsal Sağlık Poliçeleri Süreç Yönetimi Uzman",
    kurum: "Nart Brokerlık Ankara Bölge Müdürlüğü",
    yorum: "Matematik, finans, istatistik gibi bir çok alanda eğitim alındığı ve bu eğitimin Hacettepe gibi en köklü üniversitede verildiği iş arayışında büyük bir artı oluşturacağı için tercih sebebimdi.",
  },
  {
    id: 58,
    isim: "Onur Çırak",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/onurcirak.png",
    mezuniyetYili: "2016",
    pozisyon: "Bağımsız Denetim ve Danışmanlık / Aktüerya",
    kurum: "PricewaterhouseCoopers (PwC)",
    yorum: "Yazılım Sektörü ve Sigorta Sektörü başta olmak üzere; bölüm mezunlarının bu sektörler özelinde üst seviyede başarı elde ettiğinin görülmesiyle birlikte, sayılara ilgin varsa ve diğer mezunlar ile fark yaratmak istiyorsan Aktüerya Bilimleri Bölümü güzel bir fırsat.",
  },
  {
    id: 59,
    isim: "Anıl Köroğlu",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/anilkoroglu.png",
    mezuniyetYili: "2015",
    pozisyon: "Fiyatlandırma ve Data Analitiği Müdürü",
    kurum: "Unico Sigorta",
    yorum: "Henüz yaşanmamış şeylerin yaşanma ihtimalini tahmin ediyoruz, daha ne olsun ? ☺",
  },
  {
    id: 60,
    isim: "Buket Kılıçoğlu",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/buket.png",
    mezuniyetYili: "2014",
    pozisyon: "Senior Analyst",
    kurum: "Willis Towers Watson",
    yorum: "Çok para kazanabileceğimizi söyledikleri için ☺ Yoğun matematik ve istatistikle uğraşacağım için aktüeryayı tercih ettim.",
  },
  {
    id: 61,
    isim: "Işın Koçer",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/isinkocer.png",
    mezuniyetYili: "2014",
    pozisyon: "Danışman",
    kurum: "Earst &Young (EY)",
    yorum: "Matematik, istatistik ve finans becerilerimi analitik yazılımlar ile kullanıp karmaşık problemlerin üzerinden gelebileceğim bir bölüm olduğu için Hacettepe Üniversitesi Aktüerya Bilimleri.",
  },
  {
    id: 62,
    isim: "Özge Tekin",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/ozgetekin.png",
    mezuniyetYili: "2012",
    pozisyon: "Araştırma Görevlisi",
    kurum: "Orta Doğu Teknik Üniversitesi (ODTÜ)",
    yorum: "Disiplinler arası bir bilim olmasıyla farklı açılardan gelişime olanak sağladığı ve uygulamayla iç içe olması sebebiyle sürekli gelişim gösterdiği için.",
  },
  {
    id: 63,
    isim: "Soydan Demiroğlu",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/soydandemiroglu.png",
    mezuniyetYili: "2011",
    pozisyon: "Yönetici Aktüer",
    kurum: "PricewaterhouseCoopers (PwC)",
    yorum: "Gerek teknik anlamda edindiğimiz bilgilerin kalitesi gerekse sosyal anlamda bölümün sunduğu imkanlar birçoğumuza iş hayatını kolaylaştıracak önemli yetenekler kazandırmıştır.",
  },
  {
    id: 64,
    isim: "Gizem Şen",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/gizemsen.png",
    mezuniyetYili: "2011",
    pozisyon: "Uzman",
    kurum: "TÜBİTAK Strateji Geliştirme Daire Başkanlığı, Bütçe ve Performans Müdürlüğü",
    yorum: "Aktüerya bilimlerinde alınan eğitim ile, hem aktüerya gibi spesifik bir alana hem de matematik ve istatistik gibi temel bilimlere hakim olarak, sektörün ihtiyaç duyduğu donanımda bireylerin yetişmesine imkan sağlanmaktadır.",
  },
  {
    id: 65,
    isim: "Ayşe Seda Düğmeli",
    bolum: "Aktüerya Bilimleri",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/aktuerya/aysesedadugmeli.png",
    mezuniyetYili: "2007",
    pozisyon: "Müşteri Deneyimi ve Stratejileri Müdürü",
    kurum: "Allianz Türkiye",
    yorum: "Yurt dışında prestijli bir meslek ve iş olanağının olması ile birlikte spesifik bir alanda uzmanlaşma imkanı sağlaması en önemli tercih sebepleri.",
  },
  {
    id: 66,
    isim: "İlayda Arıkan",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ilaydaarikan.png",
    mezuniyetYili: "2020",
    pozisyon: "Veri Analiz Uzmanı",
    kurum: "Türk Kızılay",
    yorum: "Hacettepe Üniversitesi'nde istatistik eğitimi hem teorik hem de pratik bilgileri kapsayan geniş bir müfredat sunar. Veri analizi ve yorumlama becerilerinizi geliştirirsiniz. Python, R gibi yaygın kullanılan programlama dillerini ve analiz araçlarını etkin bir şekilde kullanmayı öğrenirsiniz. Gerçek dünya verileri üzerinde projeler yaparak pratik deneyim kazanırsınız. Eğer istatistik ve veri bilimi alanında güçlü bir akademik temel ve pratik deneyim arıyorsanız, Hacettepe Üniversitesi İstatistik bölümü sizin için doğru tercih olabilir.",
  },
  {
    id: 67,
    isim: "Zehra Korkusuz",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/zehrakorkusuz.png",
    mezuniyetYili: "2021",
    pozisyon: "Graduate Student Researcher",
    kurum: "RNA & Disease Data Science Lab Trento",
    yorum: "İstatistik mezunu olmak Joker karta sahip olmak gibi. Ben İstatistik eğitimi sayesinde şirket kurma, İtalya'ya taşınma ve Yale Üniversitesinde bir araştırma ekibiyle çalışma şansı yakaladım. Mezunlarının gördüğü bu olumlu algı ve kabulün temelinde, bölümde kazanılan karmaşık problemleri çözme becerisi, çok boyutlu verileri anlamlı bilgiye dönüştürme yeteneği ve bu bilgileri etkili bir şekilde ifade etme kabiliyeti gibi yetkinlikler var.",
  },
  {
    id: 68,
    isim: "Yasin Koçak",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/yasinkocak.png",
    mezuniyetYili: "2022",
    pozisyon: "Yazılım Geliştirici",
    kurum: "Codequarters",
    yorum: "Hacettepe Üniversitesi İstatistik Bölümünden 2022 yılında mezun oldum. 2022 yılı şubat ayından itibaren Codequarters şirketinde yazılım geliştirici olarak aktif çalışmaktayım. Bölümde aldığım 4.5 senelik eğitim öğretim serüveni içeresinde edindiğim analitik ve algoritik düşünme yapısı sayesinde dahil olduğum bir çok projede hızlı adapte olmamı sağladı.",
  },
  {
    id: 69,
    isim: "İbrahim Cengiz",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ibrahimcengiz.png",
    mezuniyetYili: "2017",
    pozisyon: "Data Analist",
    kurum: "Trendyol",
    yorum: "2017 yılında Hacettepe Üniversitesi İstatistik Bölümü'nden mezun oldum. Şu anda Trendyol'da Data Analist pozisyonunda çalışıyorum. Bu bölümde almış olduğunuz eğitimin ve size katılan vizyonun farkına özellikle mezun olup sektöre girdiğinizde varıyorsunuz. Veriyi anlamlandırmak için iyi bir eğitim almanız gerekiyor, o eğitimi de bu bölümde alabiliyorsunuz.",
  },
  {
    id: 70,
    isim: "Mert Yanik",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/mertyanik.png",
    mezuniyetYili: "2020",
    pozisyon: "Veri Bilimci",
    kurum: "LC Waikiki",
    yorum: "İstatistik bölümü analitik düşünme ve problem çözme becerilerini geliştirirken verinin gücünü anlamama da yardımcı olan bir bölümdü. Veri dünyasını sevenler için kariyer yolculuğunda istatistik bölümü en iyi adımınız olabilir.",
  },
  {
    id: 71,
    isim: "Serhat Erdem",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/serhaterdem.png",
    mezuniyetYili: "2019",
    pozisyon: "Veri Bilimci",
    kurum: "Emeklilik Gözetim Merkezi",
    yorum: "İstatistik bölümü, veri analizi, modelleme ve çıkarım yapma konularında uzmanlaşmayı sağlayan bir disiplindir. Bu bölüm, özellikle büyük veri çağında oldukça önemlidir çünkü verilerden anlamlı sonuçlar çıkarmak birçok sektör için kritik hale gelmiştir. Özetle, istatistik bölümü, geniş kariyer olanakları ve güçlü analitik beceriler kazandırması açısından oldukça değerlidir. Veri odaklı dünyada, bu becerilere sahip olmak büyük bir avantaj sağlar.",
  },
  {
    id: 72,
    isim: "Nur Yanik",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/nuryanik.png",
    mezuniyetYili: "2020",
    pozisyon: "İş Zekası Uzmanı",
    kurum: "OBASE",
    yorum: "Nerdeyse çoğu alanda iş imkanına sahip olabileceğiniz, geniş ve çeşitli kariyer fırsatları sunan bir bölüm, günümüzün veri odaklı dünyasında kritik bir öneme sahip. Ben bölümümü çok keyifle okudum umarım yeni başlayacak olan arkadaşlarım da keyifle okur :)",
  },
  {
    id: 73,
    isim: "Hıdır Can Saltık",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/hidircansaltik.png",
    mezuniyetYili: "2019",
    pozisyon: "Veri Bilimci",
    kurum: "LC Waikiki",
    yorum: "Hacettepe Üniversitesi İstatistik Bölümünden 2019 yılında bölüm ikincisi olarak mezun oldum. Mezun olmadan önce bir start-up firmasında part-time olarak çalışmaya başladım ve mezuniyetten sonra bu firmada yaklaşık 1.5 yıl veri bilimci olarak görev aldım. Ardından, bir danışmanlık şirketinde bir yıl kadar veri analitiği uzmanı olarak çalıştım. 2022 Mayıs ayından bu yana LC Waikiki'de veri bilimci olarak görev yapmaktayım. İş dünyasına rahatlıkla uyum sağlamamda en büyük etkenin Hacettepe Üniversitesi İstatistik Bölümü olduğunu düşünüyorum. Teorik ve uygulamalı derslerin yanı sıra, hocalarımızın deneyimlerini yansıtmaları sektöre adaptasyon konusunda büyük bir avantaj sağlamaktadır. İstatistik bölümü problem çözme yeteneği, analitik düşünme gücü, veri odaklı analiz becerileri kazandırdığı yetkin kişilerle her sektörde ve alanda rahatlıkla var olacaktır.",
  },
  {
    id: 74,
    isim: "Yunus Emre Karadeniz",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/yunusemrekaradeniz.png",
    mezuniyetYili: "2014",
    pozisyon: "Performance Marketing Manager",
    kurum: "Digital Marketing Agency (İtalya & USA, full remote)",
    yorum: "İstatistik mezunu olmanın sağladığı analitik bakış açısı, dijital pazarlama uzmanı olarak iş hayatımda bana önemli avantajlar sundu. Verileri anlamlandırma, analiz etme ve yorumlama, yaptığım işin etkinliğini anlama, hedef kitle analizleri ve stratejilerimi veriye dayalı kararlarla optimize etmede bu kası hep kullandım. Bu sayede, hem iş süreçlerinizi daha verimli hale getirir hem de ajansınıza önemli katkılar sağlarsınız. Ek olarak Türkiye'den yurt dışına çalışarak yani ülkeye döviz sokarak ülke ekonomisine de bir parça katkıda bulunmuş olursunuz :)",
  },
  {
    id: 75,
    isim: "Eyüp Gürcan Durum",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/eyupgurcandurum.png",
    mezuniyetYili: "2014",
    pozisyon: "İstatistikçi",
    kurum: "Tarım ve Orman Bakanlığı, Strateji Geliştirme Başkanlığı",
    yorum: "2014 Ocak mezunuyum. Bölümden 4,5 senede mezun oldum. (keşke 1-2 sene daha kalsaydım ) Tarım ve Orman Bakanlığı Strateji Geliştirme Başkanlığında istatistikçi olarak çalışıyorum. Çok fazla kendi işimi yapmasam da Hacettepe İstatistik bölümü mezunu olduğum için diğer branşlarda çalışanlardan farkımın olduğunu herkes rahatlıkla söylüyor ve ben de bu farklı görebiliyorum. Özellikle de analitik düşünme konusunda ve sayısal zekada. Zamanında aldığımız eğitimin kalitesinin farkını her geçen gün daha iyi anlıyorum. Bölümdeki hocaların gerçekten çok kaliteli olduğunu ve kıyaslanamaz olduğunu bir kere daha görmüş oldum. Dönem arkadaşlarımın hemen hemen hepsi çok güzel yerlerde çalışıyorlar. Mezun olalı 10 sene olmasına rağmen hala bölüme gidiyorum hocalarımla görüşüyorum, çalışmalarımda bana yardımcı oluyorlar. Sonuç olarak bu dediklerimin hepsi aslında anlatılmaz yaşanır.",
  },
  {
    id: 76,
    isim: "Yüksel Büşra Aşgit",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/yuksebusra.png",
    mezuniyetYili: "2019",
    pozisyon: "Data Analytics & Controlling Specialist",
    kurum: "ASELSAN",
    yorum: "Merhaba, Ben Yüksel Büşra Aşgit, 2019 yılında Hacettepe Üniversitesi İstatistik bölümünden mezun oldum. Mezuniyetimden bu yana geçen 5 yıl içinde, bölümümüz hocalarının ve aldığım eğitimin ışığında, kendimi sürekli geliştirerek iş hayatında önemli adımlar attım. Şu an Türkiye'nin önde gelen savunma sanayi şirketlerinden biri olan ASELSAN'da çalışmaktayım. Bölümümüz bizleri iş hayatına en iyi şekilde hazırlayakta ve sektörün ihtiyaç duyduğu donanımlı bireyler olarak yetiştirmektedir. Tercih döneminizde başarılar dilerim.",
  },
  {
    id: 77,
    isim: "Selin Gümüş",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/selingumus.png",
    mezuniyetYili: "2014",
    pozisyon: "Microsoft'tan Sorumlu Satış Uzmanı",
    kurum: "TD-Synnex",
    yorum: "2014 mezunuyum. TD-Synnex te Microsoft'tan sorumlu satış uzmanıyım. Bölümü tercih etmeden önce hep geleceğin konuşulan alanlarında etkin olabileceğim söylenmişti ve birçok sektörde yer alabileceğim. Şimdi görüyorum ki gerçekten öyle. Uzmanlaşmak istenilen alanın doğru seçimi ile Hacettepe İstatistik'ten mezun olup başarısız olma şansınız yok.",
  },
  {
    id: 78,
    isim: "Ceren Arslan",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ceremarslan.png",
    mezuniyetYili: "2023",
    pozisyon: "Raporlama ve Performans Uzman Yardımcısı",
    kurum: "Param",
    yorum: "Hacettepe Üniversitesi İstatistik bölümünden 2023 yılında mezun oldum. 1 yıl hazırlık 4 yıl bölüm olmak üzere 5 yıl boyunca üniversite hayatımı tamamladım. Her açıdan her konuda üniversite, bölümümüzün ve hocalarımızın farkını hissediyorum. Eğitimin kalitesini iş hayatına geçtiğinizde anlamak mümkün.",
  },
  {
    id: 79,
    isim: "Göktuğ Sayın",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/goktugsayin.png",
    mezuniyetYili: "2013",
    pozisyon: "Saha Satış Müdürü",
    kurum: "Lukoil",
    yorum: "Lukoil şirketinde Ege & Akdeniz Saha Satış Müdürü olarak çalışmaktayım. Lukoil Rusya'nın en büyük, dünyanın 12. büyük petrol üretim şirketidir. Saha Satış Müdürü olarak Lukoil bünyesinde, Lukoil standartlarında yeni bayilik yapılanması sağlanması, mevcut bayi ağının yönetilmesi, EPDK kural ve kaidelerinin yerine getirilmesinin sağlanması, pazar analizlerinin yapılması, satış geliştirme stratejileri kurarak sahadaki çalışanlar tarafından bu stratejilerin yerine getirilmesini sağlamak görev sorumluluklarından bazılarıdır. Kariyerimde (şimdi olduğu gibi) alanlarında dünya devi birçok firma ile çalışma imkanı buldum. Hem mülakat aşamasında hem de çalışma dönemlerinde Hacettepe Üniversitesi İstatistik Bölümü mezunu olmanın avantajını fazlasıyla yaşadım. Aldığımız akademik eğitimin yanında akademisyenlerimizin üstün sosyal vizyonları da hayatıma pozitif yönde katkıda bulunmuştur. İstatistik Bölümü kadar çalışma yelpazesi geniş bölüm sayısı yok denecek kadar azdır. Geleceğin İstatistikçi'lerine iyi dileklerimle....",
  },
  {
    id: 80,
    isim: "Öykü Büyükakın",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/oykubuyukakin.png",
    mezuniyetYili: "2022",
    pozisyon: "Veri Bilimci",
    kurum: "Migros Ticaret",
    yorum: "Hacettepe Üniversitesi İstatistik bölümünden 2022 yılında mezun oldum. Mezuniyetten sonra çalışma hayatıma HSBC Kredi Kartları ve Portföy Yönetimi departmanında Jr. Ürün Yöneticisi olarak başladım. Şu anda kariyerime Migros Ticaret'te İleri Analitik ve İnovasyon departmanında Veri Bilimci olarak devam ediyorum. İstatistik bölümüne başlayan veya başlamayı düşünen alana karşı ilgileri olan aday öğrencilere, bölümün analitik ve araştırmacı düşünme tarzı katması dışında Türkiye'nin ilk İstatistik bölümü olan bu bölümde kendilerini geliştirdikleri sürece sektöre ilk girdikleri andan itibaren yarattıkları farkı hissedeceklerine eminim.",
  },
  {
    id: 81,
    isim: "Berk Çelebi",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/berkcelebi.png",
    mezuniyetYili: "2022",
    pozisyon: "Veri Analisti",
    kurum: "Türk Ekonomi Bankası",
    yorum: "Selamlar, ben Berk. Hacettepe Üniversitesi İstatistik Bölümü'nden 2022 yılında mezun oldum. Mezuniyetimden yaklaşık bir hafta sonrasında halen çalışmakta olduğum Türk Ekonomi Bankası'nda Veri Analisti olarak çalışmaya başladım. Hacettepe İstatistik mezunu olmanın ayrıcalığını, bu zamana kadarki iş hayatım boyunca pek çok kez hissettim ve hissetmeye devam ediyorum. Burada alacağınız dersler ve alanında uzman değerli hocalarımızın aktaracakları bilgiler, sizleri oldukça donanımlı bir mezun yapacak ve iş hayatınızda fark yaratmanızı sağlayacak. Son olarak tabii ki sadece akademik olarak sınırlı kalmayıp, okulumuzun ve bölümün sağladığı sosyal olanakları da değerlendirirseniz, çok daha güzel bir öğrencilik hayatı yaşayacaksınızdır :)",
  },
  {
    id: 82,
    isim: "Mehmet Can Yaraşır",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/mehmetcanyarasir.png",
    mezuniyetYili: "2022",
    pozisyon: "Veri Bilimci",
    kurum: "Anadolu Ajansı",
    yorum: "Merhaba. Ben Mehmet Can YARAŞIR. Anadolu Ajansı bünyesinde Veri Bilimci olarak görev yapmaktayım. Hacettepe Üniversitesi İstatistik programı Şubat 2022 mezunuyum. Sayılar ile uğraşmaktan keyif alan, farklı bakış açısına sahip, meraklı, araştırmayı seven, yeniliklere her zaman açık ve en önemlisi detaycı bir yapınız varsa doğru zamanda doğru yerdesiniz. İstatistik, her sektörde iş imkanınızın olduğu her gün farklı konular üzerinde bilgi sahibi olabileceğiniz hem öğrenip hem eğlenerek çalışabileceğiniz bir yaşam biçimidir. Bu yaşam biçimine sahip olmak için öğrenim süreniz boyunca programlama ve analiz alanlarında kendinizi geliştirebileceğiniz bölüm derslerini almakla kalmayıp alanlarında önemli konuma sahip olan birbirinden kıymetli hocalarımızın bilgi ve deneyiminden de faydalanmanız gerekmektedir. Diğer bölüm derslerini (Dil ve Genel Kültür Dersleri) almaya olanak sağlayan, istediğiniz alanda yandal/çift anadal yapabileceğiniz ve öğrenci değişim programı anlaşması olmasa bile gitmek istediğiniz okulu bildirdiğiniz zaman okulla anlaşma yapan öğrenci gelişimine önem verdiğinden dolayı iş hayatına başladıktan sonra Hacettepe İstatistik mezunu olmanın farkını ve gururunu yaşayabilirsiniz. Son olarak bölüm zorluğu hakkında çeşitli duyumlar almış olabilirsiniz severek yaptığınız ve mantığını anladığınız takdirde hiçbir dersten kalmadan kısa zaman içerisinde diplomanızı almaya hak kazanabilirsiniz. İş hayatınızda ve hatta özel hayatınızda bile aranan kişi olmak istemez misiniz?",
  },
  {
    id: 83,
    isim: "Anıl Üye",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/aniluye.png",
    mezuniyetYili: "2022",
    pozisyon: "Veri Bilimci",
    kurum: "GETİR",
    yorum: "2022 yılında Hacettepe Üniversitesi, Fen Fakültesi İstatistik Bölümü'nden mezun oldum. Hacettepe Üniversitesi'nin bana kazandırdıklarına hem lisans eğitimi gördüğüm süreçte hem de mezun olduktan sonra birçok kez tanıklık ettim. Bu kazanımlarımdan en önemlisi, zengin müfredatı ve geliştirmemi sağladığı bakış açısıyla Hacettepe Üniversitesi'nin çalışma hayatımda farklı disiplinlere kolaylıkla adapte olmamı kolaylaştırması oldu. Çalışma hayatıma 2018 yılında havacılık yazılımları alanında faaliyet gösteren bir firmada Veri Analitiği stajyeri olarak başladım. Lisans öğrenimim sırasında almış olduğum ve istatiksel yazılımları ele alan derslerden öğrendiklerimi stajyerliğim süresince uygulama fırsatı buldum ve aynı kurumda yarı-zamanlı çalışan olarak çalışmaya devam ettim. Mezun olmadan kısa bir süre önce de Veri Bilimcisi olarak bir perakende şirketinde çalışmaya başladım.",
  },
  {
    id: 84,
    isim: "Utku Arslanoğlu",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/utkuarslanoglu.png",
    mezuniyetYili: "2021",
    pozisyon: "İş Analisti",
    kurum: "DECE YAZILIM",
    yorum: "Doktorlar, insanlar için neyse yaşadığımız çağın en değerli şeyi, veri için de istatistik odur. İstatistik ne mi demek? Bir mezun olarak karşılaştığım insanlardan aldığım tepkiyi, gelen soruları ve gösterdikleri saygıyı yaşadıktan sonra şunu diyebilirim. Yaşanan güzel yılların, güzel arkadaşlıkların ve alınan kaliteli eğitimin sağladığı bir değerler bütünü. Ve bu kazandığın değerin gelecek hakkında güzel bir yansıması olduğunu söylemek zor değil. Ama şu iki şeyi söylemeden geçemeyeceğim birincisi üniversite bir başka deyişle \"evrenkent\" okuduğun bölümden ibaret değil. Evrenin sınırlarını zorlamak gerekir. İkincisi ise \"Ne yaparsan yap sevdiğin işi yap\" gibi her başarılı insanın söylediği bu cümleyi hatırlatmak istiyorum. İstatistik tercih etmeyi düşünen kişilere de söyleyebileceğim şey şudur; İstatistik aklınıza gelebilecek her alanla her bölümle çalışma şansı sunabilir. Yapay zeka, Veri bilimi, Makine öğrenmesi gibi çağımızın en önemli ve önemi gittikçe artan alanların temeli olan İstatistiği bilmek güzel bir tercih olabilir. Ama unutulmaması gereken şey, burada yapacağınız tercihten çok vereceğiniz emeğin sonucu etkileyeceğidir. Hepinize seçiminiz ne olursa olsun başarılar… Herkesin şans eseri olduğunu düşündüğü şeye bunun matematiksel açıklamasını yapabilmek oldukça değerli bir şey…",
  },
  {
    id: 85,
    isim: "Ömer Taylan",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/omertaylan.png",
    mezuniyetYili: "2019",
    pozisyon: "Veri Bilimci",
    kurum: "Garanti BBVA Teknoloji",
    yorum: "Hacettepe İstatistik bölümünden 2019 yılında mezun oldum. Okul süreci boyunca Erasmus programı ile Portekiz'e giderek bir dönem orada okuma fırsatına sahip oldum. Son sınıfta veri analitiği üzerine danışmanlık veren bir firmada part time çalışmaya başladım ve okul bitince de aynı yerde veri bilimci olarak çalışmaya devam ettim. 3.5 yıl orada çalıştıktan sonra 2022'in başında Garanti BBVA Teknoloji'de veri bilimci olarak çalışmaya başladım. Mezun olmadan başladığım iş hayatına Hacettepe İstatistik bölümünde aldığım teorik ve uygulamalı derslerin sayesinde kolayca alışabildim. Bölümde alacağınız dersler sadece iş hayatına değil aynı zamanda hayata bakışınızı da etkileyip farklı yönden bakmanızı sağlayacaktır. Birbirinden değerli hocalardan alacağınız dersler için çok şanslı olduğunuzu unutmayın :)",
  },
  {
    id: 86,
    isim: "Mehmet Anıl İnam",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/mehmetanilinam.png",
    mezuniyetYili: "2019",
    pozisyon: "Category Specialist",
    kurum: "YEMEKSEPETİ A.Ş. (Delivery Hero)",
    yorum: "Teknoloji ve rekabetin sürekli gelişmekte olduğu özel sektörde, şirketlerin doğru yönetimi ve gelişiminin veri analizinden geldiği hipotezinin tüm kurumsal şirketler tarafından kabul görüldüğü bir dönemdeyiz. Bu dönem içerisinde yeni mezun olarak profesyonel iş hayatına başlarken eğitiminizin size kattığı teorik ve analitik bakış açısının farkını hissediyor olacaksınız. İş arkadaşlarınız ve rakipleriniz arasında donanımınız ve istatistiksel bakış açınız sayesinde karşılaşılan zorlukları aşıp başarıya ulaşma yöntemleriniz ile fark yaratabilirsiniz. Hacettepe İstatistik Bölümü müfredatı ve eğitim kadrosu sayesinde mezuniyetiniz sonrası tüm sektörlerde profesyonel iş hayatına başlayabilirsiniz. Hacettepe İstatistik Bölümünün, size sunduğu geniş sektör yelpazesini sağlayabilecek sınırlı sayıda okul ve bölüm bulunmaktadır. Hacettepe İstatistik Bölümü, içerisindeki ders çeşitliliği sayesinde mezun olmadan önce çeşitli sektörler hakkında bilgi sahibi olup, kariyerinizi erken yönlendirme imkanınız bulunuyor.",
  },
  {
    id: 87,
    isim: "Ezgi İlhan",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ezgiilhan.png",
    mezuniyetYili: "2012",
    pozisyon: "Kıdemli Müfettiş",
    kurum: "QNB Finansbank A.Ş.",
    yorum: "2012 yılında Hacettepe Üniversitesi İstatistik Bölümü'nden mezun oldum. Ardından yine Hacettepe'de MBA programını tamamlayarak okulumdaki maceramı sonlandırdım. 2015 yılından bu yana QNB Finansbank Teftiş Kurulu'nda görev almaktayım. İşe girdiğim dönemde müfettiş olarak görev yapan hatırı sayılı Fen Fakültesi mezunu bulunurken, gün geçtikçe sayımız artmakta ve değer görmekteyiz. Mevcutta bulunduğum pozisyonda risk yönetimi ve istatistiksel modellerin dokunduğu alanlarda denetimler gerçekleştiriyoruz. Analitik alanda ilerlemenin altın bilezik olduğu görüşü, gerek bulunduğum kurumda gerekse sektörde oldukça önem kazanıyor. Lisans eğitimi, Hacettepeli olmanın kalitesi ve sağladığı avantajlar ise iş hayatında bizleri destekliyor. Bu yolda ilerlemek isteyenlerin fark yaratacağı yeni bir dünya inşa edilirken, eğitim süresi boyunca sadece akademik alanla kalmayıp üniversitenin sağladığı sosyal imkanları da deneyimlemelerini tavsiye ederim.",
  },
  {
    id: 88,
    isim: "Merve Asil",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/merveasil.png",
    mezuniyetYili: "2017",
    pozisyon: "Veri Analisti",
    kurum: "Hepsiburada",
    yorum: "Merhaba, ben Merve Asil. 2012 senesinde girdiğim Hacettepe İstatistik Bölümü'nü, 1 yıllık İngilizce hazırlık eğitimi ve 4 yıllık lisans eğitiminin ardından bölüm birincisi olarak 2017 senesinde başarıyla tamamladım. IT sektöründe data alanında birçok farklı title'da görev aldım; data engineer, data analyst, data scientist gibi. Hacettepe İstatistik'in ülkemizdeki ilk istatistik bölümü olması, burayı tercih etmiş olmamdaki önemli kriterlerden biriydi. Yıllarca edinilmiş tecrübe ve üzerine güncel bilgilerin de eklenerek sürekli iyileştirilmesiyle gerçekten kaliteli bir eğitim verildiğini düşünüyorum. Mezun olduktan sonra ise, bölümün bana sağlamış olduğu en değerli katkılardan birinin analitik bakış açısı olduğunu ifade edebilirim. Günümüzün bir bilgi çağı olduğunu düşündüğümüzde, veriyi analiz etmenin ve veriden anlamlı sonuçlar elde etmenin ne kadar kritik bir öneme sahip olduğunu söylemek yanlış olmaz sanırım. Sosyal açıdan değerlendirdiğimizde de hem bölümün hem de üniversitenin ortamı, imkanları, burada kurulan dostluklar gerçekten çok kıymetli, birçok alanda kendinizi geliştirebileceğiniz bir yer. Üniversite tercihi yapacak olanlardan, ileride veri ile ilgili bir alanda çalışmak isteyen herkese Hacettepe İstatistik Bölümü'nü rahatlıkla tavsiye edebilirim.",
  },
  {
    id: 89,
    isim: "Fatma Ayoğlu Çeltikçi",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/fatmaayoglu.png",
    mezuniyetYili: "2014",
    pozisyon: "Uzman Yardımcısı",
    kurum: "Türkiye Cumhuriyeti Merkez Bankası",
    yorum: "Hacettepe Üniversitesi İstatistik Bölümü'nden mezun olduğunuz zaman, rakiplerinizden bir adım önde olduğunuzu iş başvuru ve mülakatlarında daima hissedeceksiniz. Üniversitede edindiğiniz bilgilerinizin yanına özgüveninizi eklediğinizde piyasada güzel bir konumda yer alabilme şansınız oldukça yükselecektir.",
  },
  {
    id: 90,
    isim: "Funda Bozkurt",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/fundabozkurt.png",
    mezuniyetYili: "2012",
    pozisyon: "Ekonomik Modelleme Dairesi Başkanı",
    kurum: "Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı",
    yorum: "Eğitim hayatımın önemli duraklarından olan Hacettepe Üniversitesi İstatistik Bölümünden 2012 yılında mezun oldum. Aldığım eğitim, hocalarım ve arkadaşlarımın desteğiyle 2013 yılı itibarıyla kariyerime kamu sektöründe ilk adımı attım. Kalkınma Bakanlığında uzman yardımcısı olarak başladığım görevime Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı bünyesinde Ekonomik Modelleme Dairesi Başkanı olarak devam etmekteyim. Aradan geçen zaman diliminde gördüm ki üniversite yıllarımda kazandığım akademik ve sosyal beceriler geleceğimi şekillendirmiş. Hacettepe mensubu olmak bu noktada çok büyük şans, dilerim sizler de hissedebilirsiniz. Özverili çalışmayla istediklerinize kavuşmak için İstatistik Bölümü size tüm imkânları sunacaktır. Tüm öğrencilerimize tavsiyem üniversite eğitimleri boyunca küresel eğilimleri takip etmeleri, dil eğitimlerini aksatmamaları ve Erasmus programlarını her ne pahasına olursa olsun deneyimlemeleridir. Sonrası kendiliğinden gelecek zaten…",
  },
  {
    id: 91,
    isim: "Sümeyye Derici",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/sumeyyederici.png",
    mezuniyetYili: "2014",
    pozisyon: "TÜİK Uzmanı",
    kurum: "Türkiye İstatistik Kurumu, Yöntem Araştırmaları Daire Başkanlığı",
    yorum: "2014 yılında Hacettepe Üniversitesi İstatistik Bölümü'nden mezun oldum. 2015 yılından itibaren Türkiye İstatistik Kurumu'nda çalışıyorum. Hacettepe İstatistik, öğrenmeyi öğrenme yetkinliği ile istatistiksel bakış açısı kazandırmayı hedefleyen alt yapısıyla üniversite ve meslek hayatımda çok önemli bir yere sahiptir. Seçmeli derslerin çeşitliliği, uygulamalı derslerin yoğunluğu ve değerli Hocalarımın yönlendirmeleri ilerlemek istediğiniz alanda neyi nasıl yapabileceğinizi gösteren kanallar sunuyor. Teorik derslerin de iş hayatında ne denli önemli olabileceğini özellikle istatistik konusunda derinleşmiş bir kurumda çalışınca anlıyorsunuz. Umuyorum akademik camia ve alanın iş birliği ve iletişimi artarak devam eder. İstatistik bilimindeki gelişmeleri daha iyi takip edebilmede ve üretilen istatistiklerin kalitesi artırmada bu iş birliğinin çok kıymetli olduğunu düşünüyorum.",
  },
  {
    id: 92,
    isim: "Görkem Can",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/gorkemcan.png",
    mezuniyetYili: "2014",
    pozisyon: "Business Analyst, WM CFO Advisory Team",
    kurum: "UBS Business Solutions Center/ Poland",
    yorum: "Hacettepe Üniversitesi İstatistik Bölümü, sağladığı üst düzey eğitimi ve sahip olduğu değerleri sayesinde eğitim hayatımın ve kariyerimin en önemli noktalardan birisi olmuştur. İstatistik bölümünde kazandıklarım, İtalya'nın en iyi üniversitelerinden birisi olan Universita degli studi di Padova'da tam burslu olarak ekonomi ve finans bölümünde yüksek lisans yapabilmemdeki ve dünyanın en büyük bankalarından biri olan UBS'de bulunabilmemdeki en büyük etkenlerden birisi oldu. Umuyorum bölümümüz mezunları sadece ulusal değil uluslararası alanda da kendilerini başarıya odaklarlar, çünkü gerekli altyapıya sahipler.",
  },
  {
    id: 93,
    isim: "Ferhat Genç",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ferhatgenc.png",
    mezuniyetYili: "2012",
    pozisyon: "Otomobil Bölge Satış Müdürü",
    kurum: "Hyundai Türkiye A.Ş.",
    yorum: "2012 yılında Hacettepe Üniversitesi, Fen Fakültesi İstatistik Bölümü'nden mezun oldum. 2011 yılı yaz döneminde, İngiltere'ye giderek yabancı dil gelişimime katkıda bulunup, 2012 yılının son döneminde Erasmus programı dahilinde Polonya'da Finans ve Bankacılık eğitimi aldım. Üniversite mezuniyetimin akabinde askerlik hizmetimi tamamlayıp 2014 yılında Koton firmasında \"Uluslararası Ürün Planlama Uzmanı\" olarak iş hayatıma başladım. Otomotiv sektörüne olan ilgim sebebiyle sektör değiştirip 2015 yılında Honda Türkiye A.Ş bünyesinde \"Otomobil Planlama Uzmanı\", 2016 yılında \"Bayi Ağı Geliştirme Yetkilisi\" olarak çalışıp, paralelinde 2016 yılında Sabancı Üniversitesi'nde MBA yaparak yönetimsel becerilerime katkıda bulundum. 2018 yılından günümüze, Hyundai Türkiye A.Ş bünyesinde \"Bölge Satış Müdürü\" pozisyonunda iş hayatıma devam etmekteyim. İş hayatında 4 yıl çok kısa bir zaman, bu süre zarfında bildiğim bütün istatistiksel analiz ve bakış açılarını iş hayatına yansıtıp, etkili sonuçlar alarak bunları iş arkadaşlarımla paylaştım. Aslında istatistiğin hayatımızın her anında olduğunu, aldığımız her kararın bir istatistiksel sebebinin ve sonucunun olduğunun matematiksel izahını çevremdekilere ifade etmenin ayrıcalığını yaşadım. İş hayatımda attığım her adımı ve hazırladığım her öneriyi anlamlı kılmamda katkıda bulunup, gelişimime en büyük katkıyı sağlayan Hacettepe Üniversitesi'ne ve Bölümümün tüm Saygıdeğer Öğretim Üyelerine teşekkürü her zaman borç bilirim.",
  },
  {
    id: 94,
    isim: "Doğukan Tunç",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/dogukantunc.png",
    mezuniyetYili: "2012",
    pozisyon: "Yazılım Mühendisi",
    kurum: "Uzay ve Savunma Teknolojileri (SDT)",
    yorum: "2005 yılında başladığım Lisans eğitimim sırasında kodlamaya ilgim olduğu ve mezun olduktan yazılım alanında çalışmayı hedeflediğim için bu dalda kendimi geliştirmeye başladım. Lisans eğitimim devam ederken, ilgili dersleri seçmeye özen göstermekle birlikte, okul dışında da çeşitli kurslara katılarak bilgi birikimimi artırmaya gayret ettim. Lisans eğitimim devam ettiği sırada, yazılım alanında faaliyet gösteren firmalarda tam ve yarı zamanlı çalışma deneyimlerim oldu. 2011 yılının sonunda mezun olduğumda hali hazırda tam zamanlı olarak çalışmaktaydım. 2013 yılında askerlik görevimi tamamladıktan sonra savunma sektöründe çalışmaya başladım. Bir yandan da ODTÜ Fen Bilimleri Enstitüsü bünyesinde bulunan Yazılım Mühendisliği yüksek lisans programına başlayarak, 2018 Ocak ayı itibariyle bu programdan da mezun oldum. 2013 yılından beri MİKES, ASELSAN, SDT gibi savunma firmalarında Yazılım Test ve Yazılım Geliştirme pozisyonlarında görev aldım. Halen SDT firmasında Yazılım Mühendisi pozisyonunda çalışmaktayım. Burada TAI, Aselsan, Roketsan, Havelsan gibi firmalarla beraber, ülke savunmasında ihtiyaç duyulan yazılımları ve sistemleri geliştiriyoruz. Ben C++ geliştiricisi olarak görev yapmaktayım. İstatistik biliminin bilgisayar bilimleri ile olan münasebetinin ne kadar kıymetli olduğunu, bölümümden mezun olduktan ve sektörde bir süre çalıştıktan sonra çok daha iyi anladım. Yüksek lisans programım boyunca da, bölümümüzde gördüğümüz bilgilerin ne kadar işime yaradığını yaşayarak gördükten sonra, İstatistik dalına olan saygım bir mertebe daha arttı. İletişim protokollerinde, kablosuz iletişimde veya gelişmiş yazılım örüntülerinde, lisans eğitimimde gördüğüm en temel bilgilerin ne kadar önemli ve kıymetli olduğunu deneyimleme fırsatı buldum. Aynı şekilde iş hayatında da yazılım geliştirme yaşam döngüsü içerisinde matematik ve istatistik konularının her an karşıma çıkabildiğini gördüm. Bu anlamda, her ne kadar bilgisayar bölümleri ile ayrışsa da, İstatistik bölümünün bilgisayar bilimleri, veri tabanı sistemleri ve kodlama alanında her zaman söz sahibi olması gerektiğini savunmaktayım. Bunun dışında da, bizzat istatistik alanında çalışan arkadaşlarımın da yazılım ve kodlamanın gücünü arkalarına alması gerektiği kanaatindeyim. Bu yüzden elimden geldiğince bölümümüzle bilgimi ve deneyimlerimi paylaşmaktan keyif duyuyorum. Umarım, bölümümüz öncülüğünde tüm İstatistik bölümleri, bu sektöre daha fazla kişi kazandıracak ve bu alanda varlığını, özgün yaklaşımını ve yetkinliğini hissettirecektir.",
  },
  {
    id: 95,
    isim: "İlayda Arıkan",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ilaydaarikan.png",
    mezuniyetYili: "2020",
    pozisyon: "Veri Bilimci",
    kurum: "Türk Kızılay",
    yorum: "Merhaba, adaylar! Ben İlayda Arıkan, Hacettepe Üniversitesi İstatistik bölümünden mezun bir veri bilimcisiyim ve size Hacettepe Üniversitesi'nde istatistik eğitimi hakkında bilgi vermekten memnuniyet duyarım. Hacettepe Üniversitesi, Türkiye'nin köklü ve saygın eğitim kurumlarından biridir ve özellikle istatistik alanında sağladığı akademik derinlikle bilinir. İstatistik Bölümü hem teorik hem de pratik bilgileri kapsayan geniş bir müfredat sunar. Bu müfredat içinde matematiksel istatistik, olasılık teorisi, regresyon analizi, zaman serisi analizi gibi temel istatistik konularının yanı sıra, veri madenciliği, büyük veri analizi, ve makine öğrenmesi gibi modern veri analizi tekniklerini öğrenme fırsatınız olur. Özellikle, Hacettepe Üniversitesi'nde istatistik eğitimi alarak: Veri analizi ve yorumlama becerilerinizi geliştirirsiniz. Python, R gibi yaygın kullanılan programlama dillerini ve analiz araçlarını etkin bir şekilde kullanmayı öğrenirsiniz. Gerçek dünya verileri üzerinde projeler yaparak pratik deneyim kazanırsınız. Öğretim üyelerinden ve sektör deneyimi olan misafir konuşmacılardan bilgi ve tecrübe aktarımı yapma imkanına sahip olursunuz. Lisans ve lisansüstü düzeyde araştırma projelerine katılma şansı bulabilirsiniz. Hacettepe Üniversitesi'nin sunduğu geniş öğrenci kulüpleri ve sosyal etkinliklerle de akademik yaşamınızı zenginleştirebilirsiniz. Ayrıca, üniversitenin Ankara'daki konumu, çeşitli endüstri ve araştırma merkezlerine erişim sağlamanızı kolaylaştırır, bu da kariyerinizi destekleyici bir faktördür. Eğer istatistik ve veri bilimi alanında güçlü bir akademik temel ve pratik deneyim arıyorsanız, Hacettepe Üniversitesi İstatistik bölümü sizin için doğru tercih olabilir. Umarım bu bilgiler size yardımcı olur! Başka sorularınız varsa memnuniyetle cevaplarım.",
  },
  {
    id: 96,
    isim: "Zehra Korkusuz",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/zehrakorkusuz.png",
    mezuniyetYili: "2021",
    pozisyon: "Graduate Student Researcher",
    kurum: "RNA & Disease Data Science Lab Trento",
    yorum: "İstatistik mezunu olmak Joker karta sahip olmak gibi. Ben İstatistik eğitimi sayesinde şirket kurma, İtalya'ya taşınma ve Yale Üniversitesinde bir araştırma ekibiyle çalışma şansı yakaladım. Mezunlarının gördüğü bu olumlu algı ve kabulün temelinde, bölümde kazanılan karmaşık problemleri çözme becerisi, çok boyutlu verileri anlamlı bilgiye dönüştürme yeteneği ve bu bilgileri etkili bir şekilde ifade etme kabiliyeti gibi yetkinlikler var.",
  },
  {
    id: 97,
    isim: "Yasin Koçak",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/yasinkocak.png",
    mezuniyetYili: "2022",
    pozisyon: "Yazılım Geliştirici",
    kurum: "Codequarters",
    yorum: "Hacettepe Üniversitesi İstatistik Bölümünden 2022 yılında mezun oldum. 2022 yılı şubat ayından itibaren Codequarters şirketinde yazılım geliştirici olarak aktif çalışmaktayım. Bölümde aldığım 4.5 senelik eğitim öğretim serüveni içeresinde edindiğim analitik ve algoritik düşünme yapısı sayesinde dahil olduğum bir çok projede hızlı adapte olmamı sağladı.",
  },
  {
    id: 98,
    isim: "İbrahim Cengiz",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/ibrahimcengiz.png",
    mezuniyetYili: "2017",
    pozisyon: "Data Analist",
    kurum: "Trendyol",
    yorum: "2017 yılında Hacettepe Üniversitesi İstatistik Bölümü'nden mezun oldum. Şu anda Trendyol'da Data Analist pozisyonunda çalışıyorum. Bu bölümde almış olduğunuz eğitimin ve size katılan vizyonun farkına özellikle mezun olup sektöre girdiğinizde varıyorsunuz. Veriyi anlamlandırmak için iyi bir eğitim almanız gerekiyor, o eğitimi de bu bölümde alabiliyorsunuz.",
  },
  {
    id: 99,
    isim: "Mert Yanik",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/mertyanik.png",
    mezuniyetYili: "2020",
    pozisyon: "Veri Bilimci",
    kurum: "LC Waikiki",
    yorum: "İstatistik bölümü analitik düşünme ve problem çözme becerilerini geliştirirken verinin gücünü anlamama da yardımcı olan bir bölümdü. Veri dünyasını sevenler için kariyer yolculuğunda istatistik bölümü en iyi adımınız olabilir.",
  },
  {
    id: 100,
    isim: "Serhat Erdem",
    bolum: "İstatistik",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/istatistik/serhaterdem.png",
    mezuniyetYili: "2019",
    pozisyon: "Veri Bilimci",
    kurum: "Emeklilik Gözetim Merkezi",
    yorum: "İstatistik bölümü, veri analizi, modelleme ve çıkarım yapma konularında uzmanlaşmayı sağlayan bir disiplindir. Bu bölüm, özellikle büyük veri çağında oldukça önemlidir çünkü verilerden anlamlı sonuçlar çıkarmak birçok sektör için kritik hale gelmiştir. Özetle, istatistik bölümü, geniş kariyer olanakları ve güçlü analitik beceriler kazandırması açısından oldukça değerlidir. Veri odaklı dünyada, bu becerilere sahip olmak büyük bir avantaj sağlar.",
  },
];

export const biyolojiGaleri = [
  {
    id: 1,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (30): 2014 mezunumuz Dr. Sidar AYDIN",
    link: "https://www.instagram.com/p/C-1_EZooJ08/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101753.png"
  },
  {
    id: 2,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (29): 2023 mezunumuz Reem AL-SAFFAR.",
    link: "https://www.instagram.com/p/C-KWCS7IWLy/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20102108.png"
  },
  {
    id: 3,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (25): 2014 mezunumuz Öğr. Gör. Dr. Ofcan OFLAZ",
    link: "https://www.instagram.com/p/C-E9Ztwomh2/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20102305.png"
  },
  {
    id: 4,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (15): 2014 mezunumuz Volkan SERİN.",
    link: "https://www.instagram.com/p/C948JTyo8CR/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101216.png"
  },
  {
    id: 5,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (14): 2013 mezunumuz Dr. Öğr. Üyesi Harika Eylül ESMER DURUEL.",
    link: "https://www.instagram.com/p/C94YBNjIaui/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101358.png"
  },
  {
    id: 6,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (13): 2013 mezunumuz Merve AKSOY.",
    link: "https://www.instagram.com/p/C97odxmIFKf/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101024.png"
  },
  {
    id: 7,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (18): 2011 mezunumuz Nazlı AYHAN",
    link: "https://www.instagram.com/p/C97D8vAIruw/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101059.png"
  },
  {
    id: 8,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (17): 2016 mezunumuz Gülşah Büşra ÖZKAN..",
    link: "https://www.instagram.com/p/C96tl0QooFT/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101134.png"
  },
  
  {
    id: 10,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (21): 2012 mezunumuz Dr. Merve BESLER.",
    link: "https://www.instagram.com/p/C-AGZzjoJS9/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100801.png"
  },
  {
    id: 11,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (20): 2011 mezunumuz Dr. Öğr. Üyesi Gülcan KUYUCUKLU",
    link: "https://www.instagram.com/p/C-AGZzjoJS9/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100839.png"
  },
  {
    id: 12,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (19): 2021 mezunumuz Nilay ÇOLAK",
    link: "https://www.instagram.com/p/C9unUutIan3/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100931.png"
  },
  {
    id: 13,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (3):  2010 mezunumuz Dr. Öğr. Üyesi Selen GÜÇLÜ DURGUN. ",
    link: "https://www.instagram.com/p/C9uMPvToEVc/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100607.png"
  },
  {
    id: 14,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (2): 2008 mezunumuz Dr. Öğr. Üyesi Nadide ÖZKUL DOĞRU.  ",
    link: "https://www.instagram.com/p/C9tztjHIKLw/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100652.png"
  },
  {
    id: 15,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (1): 1993 mezunumuz Hülya Özdeş.",
    link: "https://www.instagram.com/p/C9xQ3imogJl/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100258.png"
  },
  {
    id: 16,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (6): 2017 mezunumuz Ekin DEMİR. ",
    link: "https://www.instagram.com/p/C9wm3PEIjen/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100404.png"
  },
  {
    id: 17,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (5): 2012 mezunumuz Dr. Şebnem ÇIKRIK. ",
    link: "https://www.instagram.com/p/C9wY5y-In0q/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100447.png"
  },
  {
    id: 18,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (4): 2008 mezunumuz Dr. Ilgım GÖKTÜRK BAŞAL. . ",
    link: "https://www.instagram.com/p/C9zvt3lIOkT/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100023.png"
  },
  {
    id: 19,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (9):  2020 mezunumuz Tuğçe ÇALIŞKAN IŞIK.",
    link: "https://www.instagram.com/p/C9zSWNnIMfe/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100116.png"
  },
  {
    id: 20,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (8): 2012 mezunumuz Sevgi EREL.",
    link: "https://www.instagram.com/p/C9zBgSWIHwl/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20100211.png"
  },
  {
    id: 21,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (12): 2013 mezunumuz Zeynep Kevser İĞDE",
    link: "https://www.instagram.com/p/C92VB1_IXpF/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101444.png"
  },
  {
    id: 22,
    baslik: "Hacettepe Üniversitesi Biyoloji Bölümü Mezunlarımızı daha yakından tanıyalım (11): 2019 mezunumuz Cansu ULUSOY.",
    link: "https://www.instagram.com/p/C91wP1go90h/",
    foto: "https://fs.hacettepe.edu.tr/fenyeni/mezunlarimiz/Ekran%20g%C3%B6r%C3%BCnt%C3%BCs%C3%BC%202025-07-03%20101519.png"
  }
];